import React, { useState } from 'react';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import styled from 'styled-components';
import Fab from '@material-ui/core/Fab';
import { green } from '@material-ui/core/colors';
import { Link as Scroll } from 'react-scroll';

const Button = styled.div`
  position: fixed;
  left: 80%;
  bottom: 50px;
  height: 20px;
  z-index: 1000;
  cursor: pointer;
  color: green;
`;

const ScrollButton = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 750) {
      setVisible(true);
    } else if (scrolled <= 750) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  window.addEventListener('scroll', toggleVisible);

  return (
    <Button style={{ display: visible ? 'inline' : 'none' }}>
      <Scroll to='header' smooth={true}>
        <Fab onClick={scrollToTop} style={{ backgroundColor: '#006d46' }}>
          <ArrowUpwardIcon style={{ color: '#e2e1e1' }} />
        </Fab>
      </Scroll>
    </Button>
  );
};

export default ScrollButton;
